import RenderLabel from 'components/language/RenderLabel'
import React, { useEffect, useState } from 'react'

import { FormValues, WizardStepChangeEventHandler } from './types'

interface TermsOfUseAcceptanceProps {
  onChange: (value: WizardStepChangeEventHandler) => void
  formValues: FormValues
  setIsValid: (value: boolean) => void
}

const TermsOfUseAcceptance: React.FC<TermsOfUseAcceptanceProps> = ({
  onChange,
  setIsValid,
}) => {
  const [accepted, setAccepted] = useState(false)

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAccepted(e.target.checked)

    onChange({
      name: 'termsCheckboxAcceptanceDtm',
      type: 'date',
      value: new Date().toISOString(),
    })
    onChange({
      name: 'termsCheckbox',
      type: 'boolean',
      value: e.target.checked,
    })
    return
  }

  const handleReadTerms = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault()
    onChange({
      name: 'readTerms',
      type: 'boolean',
      value: true,
    })
    onChange({
      name: 'readTermsDtm',
      type: 'date',
      value: new Date().toISOString(),
    })

    window.open('/terms-of-use', '_blank')
  }

  useEffect(() => {
    setIsValid(accepted)
  }, [accepted])

  return (
    <div className="flex flex-col gap-4 mt-6">
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="termsCheckbox"
          checked={accepted}
          onChange={handleCheckboxChange}
          className="h-4 w-4 border-2 border-gray-300 bg-white rounded-sm appearance-none checked:bg-imovPrimary checked:border-imovPrimary focus:outline-none focus:ring-2 focus:ring-imovPrimary"
        />
        <label htmlFor="termsCheckbox" className="flex text-sm text-gray-700">
          <RenderLabel>iAcceptThe</RenderLabel>
          <span
            className="ml-1 text-imovPrimary cursor-pointer underline"
            onClick={e => handleReadTerms(e)}
          >
            <RenderLabel>termsOfUse</RenderLabel>
          </span>
        </label>
      </div>
    </div>
  )
}

export default TermsOfUseAcceptance
